import { Widget as WidgetShape } from '../../types/api/Widget';
import { WidgetType } from '../../types/api/ElementType';
import { useSonTranslation } from '../../translation/useSonTranslation';
import { DefaultWidgetWithHeader } from '../../_lib/components/Widget';
import { Icons } from '../../components/atoms/SVG';
import React from 'react';
import { LatestRegistrationsBlock } from '../../_blocks/LatestRegistrations/LatestRegistrationsBlock';

export type LatestRegistrationsWidgetProps = WidgetShape<[LatestRegistrationsBlock], WidgetType.latestregistrations>;

export function LatestRegistrationsWidget({ blocks, ...headerProps }: LatestRegistrationsWidgetProps) {
  const { t } = useSonTranslation('LatestRegistrations');
  return (
    <DefaultWidgetWithHeader
      {...headerProps}
      widgetType={WidgetType.latestregistrations}
      icon={Icons.LATEST_REGISTRATIONS}
      title={t('widgetTitle')}
    >
      {blocks[0] ? <LatestRegistrationsBlock {...blocks[0]} /> : null}
    </DefaultWidgetWithHeader>
  );
}
